import React, { useState , useEffect } from 'react';
import { useSelector } from 'react-redux';
import './IvMeasurementStatusInfo.css';
import '../../App.css';
import IV_REMS from '../Iv_ErrorCode/IV_REMS';
import IvError from '../Iv_ErrorCode/IvError';
import OcipError from '../Iv_ErrorCode/OcipError';
import GrowattError from '../Iv_ErrorCode/GrowattError';
import useIsRemsIv from '../../hooks/useIsRemsIv';
import useIsMobile from '../../hooks/useIsMobile';
import useIsOcipIv from '../../hooks/useIsOcipIv';
import useIsGrowatt from '../../hooks/useIsGrowatt';


const IvMeasurementStatusInfo = ({ SelInverter }) => {
  const isMobile = useIsMobile();
  const Iv_list = useSelector((state) => state.Iv_list || {});
  const [index, Setindex] = useState(null);

  // 인버터 선택 시 index 설정
    useEffect(() => {
      if (Iv_list.seq && Array.isArray(Iv_list.seq)) {
        const foundIndex = Iv_list.seq.findIndex(seq => seq === SelInverter);
        if (foundIndex !== -1) {
          Setindex(foundIndex);
        }
      }
    }, [Iv_list, SelInverter]);

    const isRems = useIsRemsIv(SelInverter);
    const isOcip = useIsOcipIv(SelInverter);
    const isGrowatt = useIsGrowatt(SelInverter);

  
    return (
    <div>
      <div style={{ margin: '10px', maxWidth: '800px' }}>
        <div className='inverterGenInfo-TopBox'>
          <div>
            <div style={{ disaply: 'flex', color: '#6B7476', fontSize: isMobile? '17px':'20px', fontWeight: '600', paddingLeft: '20px' }}>◎ 상태정보</div>
          </div>
          <div style={{ flexGrow: '1' }}></div>
          {!isRems && (
            <div style={{ marginRight: '10px', fontSize: isMobile? '14px':'16px' }}>
              정상🟢 이상🔴
            </div>
          )}
          <div style={{ color: '#6B7476', fontSize: isMobile? '17px':'20px', fontWeight: '600', paddingRight: '20px' }}>⦁ ⦁ ⦁</div>
        </div>
        
        <div className='inverterGenInfo-BottomBox'>
          <div className="container">
            {isRems ? (
              <IV_REMS SelInverter={SelInverter} />
            ) : isOcip ? (
              <OcipError SelInverter={SelInverter} />
            ) : isGrowatt ? (
              <GrowattError SelInverter={SelInverter} />
            ): (
              <IvError SelInverter={SelInverter} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IvMeasurementStatusInfo;
